import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const Description = styled.aside`
  display: inline-block;
  font-family: Helvetica;
  font-size: 22px;
  color: #505663;
  line-height: 32px;
  width: 90%;
  padding: 0 5%;
  white-space: pre-wrap;
  p {
    font-family: 'Nunito', sans-serif;
    font-size: 22px;
    color: ${props => props.light ? 'white' : '#505663'};
    line-height: 32px;
    text-align: center;
    width: 100%;
    a {
      color: #FF6F43;
      font-size: 22px;
    }
  }
  @media (min-width: ${breakpoints.desktop}) {
    width: 100%;
    padding: 0 5% 0 0;
    p {
      text-align: left;
    }
  }
`;

export default Description;



// WEBPACK FOOTER //
// ./src/styled-components/Description.js